import {
  Form,
  Loading,
  RadioButtonGroupInput,
  SaveButton,
  useGetOne,
  useInput,
  useRedirect,
  useTranslate
} from 'react-admin'
import { useFormState, useFormContext } from 'react-hook-form'
import React, { useState } from 'react'
import { Box, Grid, Input, Typography, useMediaQuery } from '@mui/material'
import log from 'loglevel'
import { isEmpty, isNil, map, replace, split, toNumber } from 'lodash/fp'
import axios from 'axios'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { HeaderLogo, setTitle } from '../Util'

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV']
const urls = !isNil(process.env['REACT_APP_APOLLO'])
  ? {
      prd: 'https://api-b2b-v2-v2.terashite.jp',
      stg: 'https://api-b2b-v2-v2-stg.terashite.jp',
      int: 'https://api-b2b-v2-v2-int.dev.terashite.jp',
      dev: 'https://api-b2b-v2-v2.dev.terashite.jp',
      exp: 'https://api-b2b-v2-v2-exp.dev.terashite.jp'
    }
  : {
      prd: 'https://api-b2b-v2.terashite.jp',
      stg: 'https://api-b2b-v2-stg.terashite.jp',
      int: 'https://api-b2b-v2-int.dev.terashite.jp',
      dev: 'https://api-b2b-v2.dev.terashite.jp',
      exp: 'https://api-b2b-v2-exp.dev.terashite.jp'
    }
const url = urls[env as keyof typeof urls]
const schemaCommon = {
  status: z.string().min(1, { message: 'required' }),
  houseStatus: z.string().min(1, { message: 'required' }),
  message: z.string().optional()
}
const schema = z.object(schemaCommon)
const checkSchema = z.object({
  message: z.string()
})

const SubmitButton: React.FC<{
  id: string
  bankAccount?: boolean
}> = ({ id, ...props }) => {
  const [enable, setEnable] = useState(false)
  const { getValues } = useFormContext()
  const { errors, isValid } = useFormState()
  const translate = useTranslate()
  const redirect = useRedirect()
  const data = getValues()
  const onSubmit = (): void => {
    setEnable(false)
    const input = {
      ...data,
      id
    }
    axios({
      url: `${url}/partner-user-public/v1/safety`,
      method: 'POST',
      data: input
    })
      .then(() => {
        redirect(`/safetyAnswer/${id}/complete`)
      })
      .catch(log.error)
  }
  React.useEffect(() => {
    setEnable(isValid)
  }, [errors, isValid])
  return (
    <SaveButton
      {...props}
      icon={<></>}
      variant="contained"
      size="large"
      disabled={!enable}
      sx={{
        borderRadius: '40px',
        backgroundColor: '#4472c4'
      }}
      label={translate('resources.safetyAnswer.submit.l1')}
      onClick={onSubmit}
    />
  )
}
const SafetyAnswerFormContent: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  // const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  const statusString = map((item: number) =>
    translate(`resources.safetyAnswer.statusString.${item}`)
  )([0, 1, 2])
  const houseStatusString = map((item: number) =>
    translate(`resources.safetyAnswer.houseStatusString.${item}`)
  )([0, 1, 2])
  const { data, isLoading } = useGetOne('safety', { id })
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box sx={{ backgroundColor: '#fff7e1' }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="h4"
                  sx={{
                    marginTop: '1.5em'
                  }}>
                  {translate('resources.safetyAnswer.title')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '-1em'
                }}>
                <picture>
                  <img src="/bar.png" alt="bar" />
                </picture>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ backgroundColor: '#f2ecda' }}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                        {
                          // @ts-expect-error ts(2339)
                          map.convert({ cap: false })(
                            (item: string, index: number) => (
                              <Typography variant="h6" key={index}>
                                {item}
                              </Typography>
                            )
                          )(split('&#13;')(data.disasterInfoText))
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ marginTop: '2em' }}>
                    <Grid container>
                      {
                        // @ts-expect-error ts(2339)
                        map.convert({ cap: false })(
                          (text: string, index: number) => {
                            return (
                              <Grid item xs={12} key={index}>
                                <Typography variant="h6">{text}</Typography>
                              </Grid>
                            )
                          }
                        )(
                          split('\n')(
                            `${translate('resources.safetyAnswer.header')}`
                          )
                        )
                      }
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'left',
                          marginTop: '2em'
                        }}>
                        <Grid item xs={1}>
                          <Typography
                            variant="h6"
                            sx={{
                              marginLeft: '0em',
                              marginTop: '-0.50em'
                            }}>
                            1:
                          </Typography>
                        </Grid>
                        <Grid item xs={11}>
                          <Typography
                            variant="h6"
                            sx={{
                              marginLeft: '0em',
                              marginTop: '-0.50em'
                            }}>
                            {translate('resources.safetyAnswer.fields.status')}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'left',
                          marginTop: '1em'
                        }}>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <RadioButtonGroupInput
                            source="status"
                            // @ts-expect-error
                            choices={map.convert({ cap: false })(
                              (name: string, index: number) => ({
                                id: `${index}`,
                                name
                              })
                            )(statusString)}
                            label={false}
                            options={{
                              // @ts-expect-error
                              size: 'large',
                              sx: { marginLeft: '0.5em', marginTop: '-1.5em' }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'left',
                          marginTop: '2em'
                        }}>
                        <Grid item xs={1}>
                          <Typography
                            variant="h6"
                            sx={{
                              marginLeft: '0em',
                              marginTop: '-0.50em'
                            }}>
                            2:
                          </Typography>
                        </Grid>
                        <Grid item xs={11}>
                          <Typography
                            variant="h6"
                            sx={{
                              marginLeft: '0em',
                              marginTop: '-0.50em'
                            }}>
                            {translate(
                              'resources.safetyAnswer.fields.houseStatus'
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'left',
                          marginTop: '1em'
                        }}>
                        <Grid item xs={1} />
                        <Grid item xs={11}>
                          <RadioButtonGroupInput
                            source="houseStatus"
                            // @ts-expect-error
                            choices={map.convert({ cap: false })(
                              (name: string, index: number) => ({
                                id: `${index}`,
                                name
                              })
                            )(houseStatusString)}
                            label={false}
                            options={{
                              // @ts-expect-error
                              size: 'large',
                              sx: { marginLeft: '0.5em', marginTop: '-1.5em' }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            marginTop: '2em'
                          }}>
                          <Grid item xs={1}>
                            <Typography
                              variant="h6"
                              sx={{
                                marginLeft: '0em',
                                marginTop: '-0.50em'
                              }}>
                              3:
                            </Typography>
                          </Grid>
                          <Grid item xs={11}>
                            <Typography
                              variant="h6"
                              sx={{
                                marginLeft: '0em',
                                marginTop: '-0.50em'
                              }}>
                              {translate(
                                'resources.safetyAnswer.fields.messageTitle'
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <TextInput
                        source="message"
                        placeholder="メッセージ(任意)"
                        multiline
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {!isEmpty(data.to) && (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">{`${translate(
                        'resources.safetyAnswer.reportTo'
                      )}: ${data.to as string}`}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '1.5em',
                  marginBottom: '2.5em'
                }}>
                <SubmitButton {...props} id={id} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
const SubmitSafetyCheckButton: React.FC<{
  id: string
  bankAccount?: boolean
}> = ({ id, ...props }) => {
  const [enable, setEnable] = useState(false)
  const { getValues } = useFormContext()
  const { errors, isValid } = useFormState()
  const translate = useTranslate()
  const redirect = useRedirect()
  const data = getValues()
  const onSubmit = (): void => {
    setEnable(false)
    const input = {
      ...data,
      id
    }
    axios({
      url: `${url}/partner-user-public/v1/safetyCheck`,
      method: 'POST',
      data: input
    })
      .then(() => {
        redirect(`/safetyCheck/${id}/complete`)
      })
      .catch(log.error)
  }
  React.useEffect(() => {
    setEnable(isValid)
  }, [errors, isValid, data])
  return (
    <SaveButton
      {...props}
      icon={<></>}
      variant="contained"
      size="large"
      disabled={!enable}
      sx={{
        borderRadius: '40px',
        backgroundColor: '#4472c4'
      }}
      label={translate('resources.safetyCheck.submit.l1')}
      onClick={onSubmit}
    />
  )
}
const SafetyCheckFormContent: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  // const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box sx={{ backgroundColor: '#fff7e1' }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {translate('resources.safetyCheck.message')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">
                        {translate('resources.safetyCheck.title')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={12}>
                    <TextInput
                      source="message"
                      placeholder="ご意見・ご要望"
                      multiline
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1.5em',
                marginBottom: '2.5em'
              }}>
              <SubmitSafetyCheckButton {...props} id={id} />
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
const SafetyReportFormContent: React.FC<{
  id: string
}> = ({ id }) => {
  // const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  const statusString = map((item: number) =>
    translate(`resources.safetyAnswer.statusString.${item}`)
  )([0, 1, 2])
  const houseStatusString = map((item: number) =>
    translate(`resources.safetyAnswer.houseStatusString.${item}`)
  )([0, 1, 2])
  const { data, isLoading } = useGetOne('safety', { id })
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box sx={{ backgroundColor: '#fff7e1' }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="h4"
                  sx={{
                    marginTop: '1.5em'
                  }}>
                  {translate('resources.safetyReport.title')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '-1em'
                }}>
                <picture>
                  <img src="/bar.png" alt="bar" />
                </picture>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ backgroundColor: '#f2ecda' }}>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      {
                        // @ts-expect-error ts(2339)
                        map.convert({ cap: false })(
                          (item: string, index: number) => (
                            <Typography variant="h6" key={index}>
                              {item}
                            </Typography>
                          )
                        )(split('&#13;')(data.disasterInfoText))
                      }
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">{`${translate(
                        'resources.safetyReport.reportFrom'
                      )}: ${data.from as string}`}</Typography>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={12} sx={{ marginTop: '2em' }}>
                  <Grid container>
                    {
                      // @ts-expect-error ts(2339)
                      map.convert({ cap: false })(
                        (text: string, index: number) => {
                          return (
                            <Grid item xs={12} key={index}>
                              <Typography variant="h6">
                                {replace(/name/, data.from)(text)}
                              </Typography>
                            </Grid>
                          )
                        }
                      )(
                        split('\n')(
                          `${translate('resources.safetyReport.header')}`
                        )
                      )
                    }
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '2em'
                      }}>
                      <Grid item xs={1}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          1:
                        </Typography>
                      </Grid>
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${translate(
                            'resources.safetyAnswer.fields.status'
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '1em'
                      }}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${statusString[toNumber(data.status)] as string}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '2em'
                      }}>
                      <Grid item xs={1}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          2:
                        </Typography>
                      </Grid>
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${translate(
                            'resources.safetyAnswer.fields.houseStatus'
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '1em'
                      }}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${
                            houseStatusString[
                              toNumber(data.houseStatus)
                            ] as string
                          }`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '2em'
                      }}>
                      <Grid item xs={1}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          3:
                        </Typography>
                      </Grid>
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${translate(
                            'resources.safetyAnswer.fields.messageTitle'
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {!isNil(data.message) && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        marginTop: '1em'
                      }}>
                      <Grid item xs={1} />
                      <Grid item xs={11}>
                        <Typography
                          variant="h6"
                          sx={{
                            marginLeft: '0em',
                            marginTop: '-0.50em'
                          }}>
                          {`${data.message as string}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
const SafetyNotifyFormContent: React.FC<{
  id: string
}> = ({ id }) => {
  // const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box sx={{ backgroundColor: '#fff7e1' }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="h4"
                  sx={{
                    marginTop: '1.5em'
                  }}>
                  {translate('resources.safetyNotification.title')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '-1em'
                }}>
                <picture>
                  <img src="/bar.png" alt="bar" />
                </picture>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    {
                      // @ts-expect-error ts(2339)
                      map.convert({ cap: false })(
                        (item: string, index: number) => (
                          <Typography variant="h6" key={index}>
                            {item}
                          </Typography>
                        )
                      )(split('&#13;')(data.disasterInfoText))
                    }
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h6">
                      {translate('resources.safetyNotification.message')}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {!isNil(data.message) && (
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="h6">{data.message}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export const TextInput: React.FC<{
  source: string
  placeholder: string
  validate?: any
  multiline: boolean
}> = ({ source, placeholder, validate, multiline, ...props }) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('md'))
  const { field, isRequired } = useInput({ source, validate, ...props })
  // const translate = useTranslate()
  // const label = translate(`resources.safetyAnswer.fields.${field.name}`)
  const { errors } = useFormState()
  const multilineValue = isNil(multiline) ? false : multiline
  return (
    <>
      {/* <Typography variant="subtitle1">{label}</Typography> */}
      <Box
        {...props}
        border={1}
        sx={{
          minHeight: '3em',
          display: 'flex',
          alignContent: 'center',
          marginTop: isDesktop ? '0.1em' : '0.25em',
          marginLeft: isDesktop ? '0.50em' : '0.25em',
          borderRadius: '10px',
          borderColor: '#c5c5c5'
        }}>
        <Input
          {...field}
          placeholder={placeholder}
          fullWidth
          disableUnderline
          minRows={3}
          sx={{ marginLeft: '1em', marginRight: '1em', fontSize: '20px' }}
          required={isRequired}
          multiline={multilineValue}
        />
      </Box>
      {!isNil(errors[source]?.message) && <ValidateError source={source} />}
    </>
  )
}
export const ValidateError: React.FC<{
  source: string
}> = ({ source }) => {
  const translate = useTranslate()
  const { errors } = useFormState()
  return (
    <Typography variant="subtitle2" color="red" sx={{ marginLeft: '1em' }}>
      {translate(errors[source]?.message as string)}
    </Typography>
  )
}
export const SafetyReportForm: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  return (
    <Form>
      <SafetyReportFormContent {...props} id={id} />
    </Form>
  )
}
export const SafetyNotifyForm: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  return (
    <Form>
      <SafetyNotifyFormContent {...props} id={id} />
    </Form>
  )
}
export const SafetyAnswerForm: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  return (
    <Form resolver={zodResolver(schema)} defaultValues={{ message: '' }}>
      <SafetyAnswerFormContent {...props} id={id} />
    </Form>
  )
}
export const SafetyAnswerCompleteForm: React.FC<{ id: string }> = ({ id }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box
          sx={{
            backgroundColor: '#fff7e1',
            paddingTop: '2em',
            paddingBottom: '3em'
          }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: '0em'
                  }}>
                  {translate('resources.safetyAnswerReport.message')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
export const SafetyCheckForm: React.FC<{
  id: string
}> = ({ id, ...props }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  return (
    <Form resolver={zodResolver(checkSchema)}>
      <SafetyCheckFormContent {...props} id={id} />
    </Form>
  )
}
export const SafetyCheckCompleteForm: React.FC<{ id: string }> = ({ id }) => {
  const translate = useTranslate()
  const { data, isLoading } = useGetOne('safety', { id })
  React.useEffect(() => {
    if (isLoading) return
    const { partner } = data
    setTitle(partner, translate)
  }, [isLoading, data, translate])
  if (isLoading) return <Loading />
  const { partner } = data
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '1280px' }}>
        <Box sx={{ marginLeft: '0.5em' }}>
          <HeaderLogo partner={partner} />
        </Box>
        <Box
          sx={{
            backgroundColor: '#fff7e1',
            paddingTop: '2em',
            paddingBottom: '3em'
          }}>
          <Box sx={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
            <Grid
              container
              justifyContent="center"
              spacing={2}
              sx={{
                marginTop: '0.1em'
              }}>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: '0em'
                  }}>
                  {translate('resources.safetyCheckReport.message')}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
